import { useQuery } from '@tanstack/react-query';
import { edupassClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import type { Course } from '@/models/catalog/course';

export interface CatalogFilters {
  ids?: number[];
  terms?: string;
  course_types?: string[];
  knowledge_areas?: number[];
  institutions?: number[];
  modalities?: string[];
  features?: string[];
  states?: string[];
  city?: string;
  budget?: {
    min: number;
    max: number;
  };
}

export enum CatalogSort {
  None = 'none',
  Relevance = 'relevance',
  PriceAsc = 'price_asc',
  PriceDesc = 'price_desc',
  FreeOriginalPriceFirst = 'free_original_price_first',
}

interface CatalogSearchRequest {
  filters?: CatalogFilters;
  sort?: CatalogSort;
  page?: number;
  page_size?: number;
}

interface CatalogSearchResponse {
  items: Course[];
  showcase: Course[];
  pagination: {
    total: number;
    total_pages: number;
    page: number;
    page_size: number;
  };
}

export const useCatalogSearch = (
  requestParams: CatalogSearchRequest,
  enabled: boolean = true
) => {
  const result = useQuery({
    queryKey: [clientKeys.catalogSearch, requestParams],
    queryFn: async () => {
      const response = await edupassClient.post<CatalogSearchResponse>(
        '/catalog/search',
        { ...requestParams }
      );
      return response.data;
    },
    enabled,
  });

  return { ...result, catalog: result.data?.items ?? [] };
};
